<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
      v-show="addshow"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      + Add Policy
    </button>
    <a-modal v-model="visible" title="Add a new Policy">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
          >+ Add Policy</a-button
        >
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Phone">
          <a-input
            placeholder="Phone"
            v-decorator="[
              'phone',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input a valid phone!',
                    pattern: new RegExp(`^[0-9]{7,14}$`),
                  },
                ],
              },
            ]"
          >
            <a-select
              slot="addonBefore"
              v-decorator="['country_code', { initialValue: '91' }]"
              style="width: 70px"
            >
              <a-select-option
                v-for="countryCode in countryCodes"
                :value="countryCode.value"
                :key="countryCode.value"
              >
                <span class="text-bold">{{ countryCode.name }}</span>
              </a-select-option>
            </a-select>
          </a-input>
        </a-form-item>

        <a-form-item label="Email">
          <a-input
            placeholder="Email"
            v-decorator="[
              'email_id',
              { rules: [{ required: true, message: 'Please input Email!' }] },
            ]"
          />
        </a-form-item>
        <a-form-item label="Address">
          <a-input
            placeholder="Address"
            v-decorator="[
              'address',
              {
                rules: [{ required: true, message: 'Please input Address !' }],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="Terms and Condition">
          <a-input
            placeholder="Terms and Conditions"
            v-decorator="[
              'terms_and_conditions',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input Terms and Conditions !',
                  },
                ],
              }
            ]"
          />
        </a-form-item>

        <a-form-item label="Privacy Policy">
          <a-input
            placeholder="Privacy Policy"
            v-decorator="[
              'privacy_policy',
              {
                rules: [
                  { required: true, message: 'Please input Privacy Policy !' },
                ],
              },
            ]"
          />
        </a-form-item>

        <a-form-item label="About Us">
          <a-input
            placeholder="About Us"
            v-decorator="[
              'about_us',
              {
                rules: [{ required: true, message: 'Please input About Us !' }],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { countryCodes } from '../../../school/Forms/data'
export default {
  name: 'SchoolPrivacyPolicy',
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      isShow: false,
      data: [],
      meta: {},
      current: 1,
      addshow: false,
      pageSize: 10,
      schId: null,
      countryCodes,
    }
  },
  mounted: function () {
    this.getPolicy()
  },
  computed: {
    schoolId: function () {
      return this.$route.params.id
    },
  },
  methods: {
    getPolicy: function () {
      this.loading = true
      this.$http
        .get(`/api/school-privacy-policy/${this.schoolId}`, {
          params: {
            limit: this.pageSize,
            page: this.current,
          },
        })
        .then(({ data }) => {
          this.loading = false
          this.data = [data.data]
          this.meta = data.meta
          if (Object.keys(data.data).length === 0) {
            this.addshow = true
          } else {
            this.addshow = false
          }
        })
    },
    showModal() {
      this.visible = true
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.privacy_policy}?`,
            content: `Click on the OK button to add the new Policy!`,
            onOk: () => {
              this.$http
                .post('/api/privacy/add', {
                  address: values.address,
                  email_id: values.email_id,
                  phone: values.country_code + values.phone, // adding country code in phone number
                  terms_and_conditions: values.terms_and_conditions,
                  privacy_policy: values.privacy_policy,
                  about_us: values.about_us,
                  school_id: this.schoolId,
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Privacy Policy successfully added',
                    description: `${data.data.privacy_policy} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
              this.addshow = false
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
